import React from "react";
import ReactDOM from "react-dom";
import VRController from "../VRComponent/components/VRController";
import { VRWrapper, notifyStileOnSafari } from "../VRComponent/SafariResizeFix";
import "../../../scss/reset.scss";

window.onload = () => {
    notifyStileOnSafari();

    ReactDOM.render(
        <VRWrapper>
            <VRController
                splashImage={require("./assets/splash.png")}
                videoSrc={require("./assets/nepal.mp4")}
                title={"Nepal – post earthquake"}
            />
        </VRWrapper>,
        document.querySelector("#react-components"),
    );
};
